__turbopack_context__.v({
  "headerImage": "SubsectionCard-module__aliCCG__headerImage",
});
